export const TITAN_EVENTS = {
  EXPERIMENT_VIEWED: 'experiment_viewed',
  CHECKOUT_STEP_VIEWED: 'checkout_step_viewed',
  ORDER_COMPLETED: 'order_completed',
  PROMOTION_VIEWED: 'promotion_viewed',
  PROMOTION_CLICKED: 'promotion_clicked',
  PRODUCT_LIST_VIEWED: 'products_list_viewed',
  PRODUCT_ADDED: 'product_added',
  ADDITIONAL_ORDER: 'additional_order',
  ORDER_CANCELLED: 'order_cancelled',
};

export const PROMOTION_IDS = {
  USER_PREFERENCES: 'user_preferences',
};

export const PRODUCT_LIST_IDS = {
  PUDO_OPTIONS: 'pudo_options',
};

export const TITAN_EXPERIMENT_IDS = {
  RETURNS_MULTIORDER_LOOP_LINK: 'returns-multiorder-loop-link',
};
